import { atom } from "jotai";
import type { UserResponse } from "@models/user";

export const currentUserAtom = atom<UserResponse | null>(null);

export const isFetchingUserAtom = atom<boolean>(false);

// True when the last GET /users/me failed. Lets a gate that is waiting on
// currentUserAtom tell "still loading" from "failed" (AdminRoute).
export const userFetchErrorAtom = atom<boolean>(false);

export const isProcessingUserAtom = atom<boolean>(false);
